import React from "react";

const Filters = () => {
  return <div></div>;
};

export default Filters;
